var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "make-invoice-adjust-balance-dialog",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("Invoice.invoice_updateRemark"),
            width: "750px",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c("div", [
            _c(
              "div",
              {
                staticClass: "app-el-transfer_text",
                attrs: { align: "center" }
              },
              [
                _c("ul", [
                  _c("li", [_vm._v(_vm._s(_vm.$t("Clearing.PleaseNote")))]),
                  _c("li"),
                  _c("li", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("Clearing.ChangesTheNextInvoiceConfiguration")
                      )
                    )
                  ]),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("Clearing.EBeLessThanCharacters")))
                  ]),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("Clearing.PaperBeLessThanCharacters")))
                  ]),
                  _c("li", [
                    _vm._v(
                      _vm._s(_vm.$t("Clearing.AutomaticTheTextDoesntLine"))
                    )
                  ]),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("Clearing.PDFDisplayUpToLines")))
                  ])
                ])
              ]
            ),
            _c(
              "div",
              { staticClass: "app-el-transfer" },
              [
                [
                  _c("el-transfer", {
                    ref: "transfer",
                    attrs: {
                      id: "transfer",
                      "target-order": "push",
                      data: _vm.listData,
                      titles: [
                        _vm.$t("Clearing.NotUsed"),
                        _vm.$t("Clearing.Used")
                      ]
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var option = ref.option
                          return _c(
                            "span",
                            {
                              attrs: { draggable: !option.disabled },
                              on: {
                                dragstart: function($event) {
                                  return _vm.drag($event, option)
                                }
                              }
                            },
                            [
                              option.key == 18
                                ? _c(
                                    "label",
                                    {
                                      staticClass: "app-el-transfer-label",
                                      attrs: {
                                        title: _vm.$t(
                                          "Clearing.Example8180onlyUSDIsInvoice"
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(" " + _vm._s(option.label) + " "),
                                      _c("img", {
                                        attrs: {
                                          src: "/static/q.png",
                                          width: "13",
                                          height: "13"
                                        }
                                      })
                                    ]
                                  )
                                : _c(
                                    "label",
                                    { staticClass: "app-el-transfer-label" },
                                    [_vm._v(" " + _vm._s(option.label) + " ")]
                                  )
                            ]
                          )
                        }
                      }
                    ]),
                    model: {
                      value: _vm.transferValue,
                      callback: function($$v) {
                        _vm.transferValue = $$v
                      },
                      expression: "transferValue"
                    }
                  })
                ]
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "triggers", attrs: { align: "center" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", no: "1" },
                    on: { click: _vm.saveConfig }
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.$t("common.btn.confirmUpdate")) + " "
                    )
                  ]
                ),
                _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "30px" },
                    attrs: { type: "primary", no: "2" },
                    on: { click: _vm.cancel }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common.btn.back")) + " ")]
                )
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }